import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import posthog from 'posthog-js';

if (environment.production) {
  enableProdMode();
}

if (environment.posthogKey) {
  posthog.init(environment.posthogKey, {
    api_host: environment.posthogHost,
    capture_pageview: false,
    disable_session_recording: true,
    autocapture: {
      dom_event_allowlist: ['click'],
      element_allowlist: ['button'],
    },
  });
  posthog.register({ env: environment.name });
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => {
    console.log(err);
  });
